import React from "react";
import ReactDOM from "react-dom";
import App from "./routes/App";

import "./i18n/i18n";

import "./assets/scss/index.scss";
// import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// serviceWorker.unregister();
